import DiscountCostPool from './discount_cost_pool.vue';

export default DiscountCostPool;
